import React, { useState } from "react";
import defaultimg from "../../assets/img/user6.png";
import ActiveFormModal from "../ActiveFormModal";
import { useDispatch } from "react-redux";
import { getAllItems, updateItem } from "../../actions/itemActions";
import AdminItemEditModal from "./AdminItemEditModal";

const StoreAdminItemsListRow = ({ current, i }) => {
  const [showEditCategoryModal, setshowEditCategoryModal] = useState(false);
  const openEditCategoryModal = () => {
    setshowEditCategoryModal((showEditCategoryModal) => !showEditCategoryModal);
  };
  const [showActiveModal, setshowActiveModal] = useState(false);
  const openActiveModal = () => {
    setshowActiveModal((showActiveModal) => !showActiveModal);
  };
  console.log(current, "currenttttttt modal k bhr");
  const dispatch = useDispatch();
  // const [values, setValues] = useState({
  //   _id: "",
  //   status: "",
  // });
  const handleSubmit = async (event) => {
    event.preventDefault();
    const updatedStatus = !current.status; // Toggle the boolean value
    const statusData = {
      _id: current.id,
      status: updatedStatus, // Assign the toggled value
    };
    dispatch(updateItem(statusData));

    setTimeout(() => {
      dispatch(getAllItems());
    }, 1000);
    setshowActiveModal(false);
  };
  return (
    <>
      <tr key={i}>
        <td>122</td>
        <td>
          <img
            src={
              current?.itemPic?.fileUrl ? current?.itemPic?.fileUrl : defaultimg
            }
            className="default-pic-height rounded border"
            alt=""
            width="50"
            height="50"
          />
        </td>
        <td>{current.name}</td>
        <td>{current.sellPrice}$</td>
        <td>
          {/* <button className="btn-sm btn-primary"> */}
          In stock
          {/* </button> */}
        </td>
        <td>4(5)</td>
        <td>
          <a href="#" className="btn btn-sm btn-success">
            Active
          </a>
          <a href="#" className="btn btn-sm btn-primary">
            Edit
          </a>
        </td>
      </tr>
      <ActiveFormModal
        openActiveModal={openActiveModal}
        showActiveModal={showActiveModal}
        current={current}
        handleSubmit={handleSubmit}
      />
      <AdminItemEditModal
        openEditCategoryModal={openEditCategoryModal}
        showEditCategoryModal={showEditCategoryModal}
        current={current}
      />
    </>
  );
};

export default StoreAdminItemsListRow;
